/**
 * @generated SignedSource<<e9aab3bf5ff14e4cbd5dee19f21c2c04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalScheduleSetPublishAtMutation$variables = {
  archiveAt?: string | null;
  id: string;
  publishAt?: string | null;
};
export type WorkspaceSignalScheduleSetPublishAtMutation$data = {
  readonly signalWorkspace: {
    readonly updateScheduledPublishAt: {
      readonly id: string;
      readonly scheduledPublishAt: {
        readonly isoString: string;
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      } | null;
    };
  };
};
export type WorkspaceSignalScheduleSetPublishAtMutation$rawResponse = {
  readonly signalWorkspace: {
    readonly updateScheduledPublishAt: {
      readonly id: string;
      readonly scheduledPublishAt: {
        readonly __isDate: "UnzonedDate";
        readonly isoString: string;
      } | null;
    };
  };
};
export type WorkspaceSignalScheduleSetPublishAtMutation = {
  rawResponse: WorkspaceSignalScheduleSetPublishAtMutation$rawResponse;
  response: WorkspaceSignalScheduleSetPublishAtMutation$data;
  variables: WorkspaceSignalScheduleSetPublishAtMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "archiveAt"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "publishAt"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "newArchiveAt",
    "variableName": "archiveAt"
  },
  {
    "kind": "Variable",
    "name": "newPublishAt",
    "variableName": "publishAt"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalScheduleSetPublishAtMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "updateScheduledPublishAt",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "scheduledPublishAt",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FormattedDate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceSignalScheduleSetPublishAtMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "updateScheduledPublishAt",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "scheduledPublishAt",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "369e03c697b02a364e313eff15a759af",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalScheduleSetPublishAtMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceSignalScheduleSetPublishAtMutation(\n  $id: ID!\n  $publishAt: String\n  $archiveAt: String\n) {\n  signalWorkspace(id: $id) {\n    updateScheduledPublishAt(newPublishAt: $publishAt, newArchiveAt: $archiveAt) {\n      id\n      scheduledPublishAt {\n        isoString\n        ...FormattedDate\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "c00e565e9f9f30b23a9b04a54fc386e3";

export default node;
